export default __webpack_public_path__ + "static/media/ConfiguracaoIconGrey.07b44695.svg";